<script>
  import { createEventDispatcher, tick } from "svelte";
  import { onMount } from "svelte";
  import ChatTextBox from "./chat/ChatTextBox.svelte";
  import ChatFileUploadBox from "./chat/ChatFileUploadBox.svelte";
  import ChatCheckBox from "./chat/ChatCheckBox.svelte";
  import ChatSelect from "./chat/ChatSelect.svelte";
  import ChatSelectWithButtons from "./chat/ChatSelectWithButtons.svelte";
  import ChatBubbleBot from "./chat/ChatBubbleBot.svelte";
  import ChatBubbleUser from "./chat/ChatBubbleUser.svelte";
  import ChatBubbleBotFreeText from "./chat/ChatBubbleBotFreeText.svelte";
  import TelField from "./base/TelField.svelte";
  import Button from "./base/Button.svelte";
  import Closer from "./base/Closer.svelte";
  import Typography from "./base/Typography.svelte";
  import { sendform, fileUpload, getHost } from "../utils/sendwhatsapp_rewrite_chabi";
  import Spinner from "./base/Spinner.svelte";
  import { currentLanguage, isClosedConversationStore } from "../store";
  import ChatGenderSelector from "./chat/ChatGenderSelector.svelte";
  import ChatDatePicker from "./chat/ChatDatePicker.svelte";
  import ChatTimePicker from "./chat/ChatTimePicker.svelte";
  import SearchableSelect from "./base/SearchableSelect.svelte";
  import { addHttpsToUrl, getWrittenName, toArray, interpolatePageVariables, normalizeUrlFieldValue } from "../utils/utilities";
  import translations from "../translations";
  import MultiSelect from "./base/MultiSelect.svelte";

  export let data;
  export let activePerson;
  export let isBigperson = false;
  export let formOverride = null;

  let sent = false;
  let err = false;
  let index = 0; // Index of the current form item
  let height;
  let screenHeight;
  let isLoading = false;
  let cookieModalExist = eval("typeof modalPrivacityTermsCookies") === "function";
  let currentLang = "en";

  $: activeForm = formOverride ?? activePerson.form;
  $: formitems = activeForm.items;
  $: buyLinks = activeForm.buyLinks;
  $: type = "text";
  $: hasBuyLinks = (sent === true || isSent()) && buyLinks && buyLinks.length > 0;
  $: fullScreenMobile = data.expandFullScreenMobile;
  $: fullScreenMobileStyle = fullScreenMobile && (screenHeight > height ? "height:100%;" : "height:max-content;");
  $: notQualified = false;
  $: sendMessage = data.transSuccessMessage ?? "Your message has been sent";
  $: closeConversationIndex = -1;

  onMount(() => {
    // Subscribe to changes in currentLanguage
    currentLanguage.subscribe((value) => {
      currentLang = value;
    });

    formitems.forEach((item) => {
      if (item.type === "checkbox") {
        if (item.showPrice && item.price && item.price > 0) {
          item.label = item.label + " (" + item.price + " " + data.currency + ")";
        }
      }
    });
    index = formitems.findIndex((item) => !item.val && !["step", "hidden", "hidden2"].includes(item.type) && item.filtered !== true);
    type = formitems[index]?.type;
  });

  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch("close");
  }

  const showBot = (i, bubble) => {
    if (closeConversationIndex === i) {
      return false;
    }
    const activeItems = formitems.slice(0, i).filter((item) => item.type !== "step" && item.type !== "hidden" && item.type !== "hidden2" && item.filtered !== true);
    if (activeItems.length === 0) {
      return true;
    } else if (activeItems[activeItems.length - 1].val) {
      return true;
    }
    return false;
  };

  const showDot = (i) => {
    if (formitems[i].val) {
      return false;
    }
    return true;
  };

  const showUser = (i, bubble) => {
    if (formitems[i].val && bubble.type !== "freetext") {
      return true;
    }
    return false;
  };

  const isSent = () => {
    const activeItems = formitems.filter((item) => item.type !== "freetext" && item.type !== "step" && item.type !== "hidden" && item.type !== "hidden2");

    if (activeItems.length === 0) return false;

    // Verificar si el último campo activo tiene valor
    return activeItems[activeItems.length - 1].val ? true : false;
  };

  const setVal = async (v) => {
    let objDiv = document.getElementById("messageBox");
    if (objDiv) {
      objDiv.scrollTop = objDiv.scrollHeight;
    }

    index = formitems.findIndex((obj) => !obj.val && obj.filtered !== true && obj.type !== "step" && obj.type !== "hidden" && obj.type !== "hidden2");
    // Si no hay más campos visibles, retornar
    if (index === -1) return;

    let val;
    if (type == "tel") {
      val = v.detail.num === "" ? "" : v.detail.code + v.detail.num;
    } else if (type == "number") {
      val = v.detail;      
    } else if (type != "file") {
      val = v.detail.trim();
    } else {
      val = v.detail;
      formitems[index].name = val.name;
    }
    if (type === "url") {
      val = normalizeUrlFieldValue(val);
    }

    let required = activeForm.items[index].required;
    if (type === "checkbox") {
      required = required && activeForm.items[index].legalUrl;
    }

    if (
      !validate(
        type,
        type === "tel" ? v.detail : val,
        required,
        formitems[index].validation,
        formitems[index].subtype
      )
    )
      return false;

    if (type === "email" && formitems[index].serverValidation === true && val !== "") {
      try {
        isLoading = true;
        const res = await fetch(`${getHost()}/api/widget/${data.id}/email/validate?email=${encodeURIComponent(val)}`);
        const result = await res.json();
        if (result.valid === false) {
          err = result.message || (data.emailValidationText ?? translations.emailValidationText[currentLang]);
          isLoading = false;
          return false;
        }
      } catch (e) {
        // If server unreachable, don't block submission
      } finally {
        isLoading = false;
      }
    }

    formitems[index].val = val;
    formitems[index].emptyOptionalUrlAnswered = type === "url" && val === "" && !required;

    formitems.forEach((item, i) => {
      if (item.fieldToFilterFrom) {
        const values = item.valueToFilterFrom.split("|");

        const checkItem = formitems[item.fieldToFilterFrom - 1];
        let isFiltered = true;
        values.forEach((value) => {
          if (checkItem.type === "checkbox") {
            if ((checkItem.val === "Yes" && value === "1") || (checkItem.val === "No" && value !== "1")) {
              isFiltered = false;
            }
          } else if (checkItem.val && value.trim() === checkItem.val.trim()) {
            isFiltered = false;
          }
        });
        formitems[i].filtered = isFiltered;
      }
    });

    if (!isLastSend(index, formitems)) {
      index = formitems.findIndex((obj) => !obj.val && obj.emptyOptionalUrlAnswered !== true && obj.type !== "step" && obj.type !== "hidden2" && obj.type !== "hidden" && obj.filtered !== true);

      updateProgressBar(index);
      type = formitems[index].type;
      scrollToBottom();
    } else {
      // CAMBIO 3: Asignar valores a campos hidden ANTES de procesar archivos
      formitems.forEach((item) => {
        if (item.type === "hidden") {
          item.val = item.value ?? item.hval;
        }
        if (item.type === "hidden2") {
          item.val = item.value ?? item.hval;
        }
      });

      // Check if there are any file uploads and upload them
      for (let i in formitems) {
        if (formitems[i].type === "file" && formitems[i].val) {
          isLoading = true;
          const res = await fileUpload(formitems[i].val, activePerson.id);
          formitems[i].val = res?.data?.id;
        }
      }

      sent = true;
      if (!buyLinks || buyLinks.length === 0) {
        let scoreCnt = 0,
          scoreSum = 0,
          score;
        if (activeForm.activateScoringFilter) {
          for (let item of formitems) {
            if (item.type === "select") {
              score = item.dataObject.find((obj) => obj.value === item.val).score;
              switch (score) {
                case "gold":
                  scoreSum += 3;
                  break;
                case "silver":
                  scoreSum += 2;
                  break;
                case "bronze":
                  scoreSum += 1;
                  break;
              }
              scoreCnt++;
            }
          }
        }
        notQualified =
          (scoreCnt > 0 && scoreSum / scoreCnt < 2) ||
          (activePerson.online === false && data.offlineLeads === true) ||
          (data.desktopLeads === true && window.innerWidth > 1000);

        if (closeConversationIndex > -1) {
          notQualified = false;
        }

        for (let i in activeForm.items) {
          if (activeForm.items[i].type === "hidden") {
            activeForm.items[i].val = activeForm.items[i].value ?? activeForm.items[i].hval;
          }
          if (activeForm.items[i].type === "hidden2") {
            activeForm.items[i].val = activeForm.items[i].value ?? activeForm.items[i].hval;
          }
        }

        dispatch("callmex", { data: combineFormsAndRemoveDuplicates(formitems, activeForm), notQualified });
      }
    }

    if (objDiv) {
      setTimeout(() => {
        objDiv.scrollTop = objDiv.scrollHeight;
      }, 300);
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  };

  /**
   * Combines form items and removes duplicates.
   *
   * @param {Array} formitems - Array of form items.
   * @param {Object} activePersonForm - Active person form object.
   * @returns {Array} - Array of unique form items.
   */
  const combineFormsAndRemoveDuplicates = (formitems, activePersonForm) => {
    // Los campos hidden ya tienen sus valores asignados en formitems
    const toSendArray = formitems
      .filter((item) => item.type !== "freetext" && item.type !== "step")
      .map((item) => {
        const { emptyOptionalUrlAnswered, ...cleanItem } = item;
        return cleanItem;
      });

    // Eliminar duplicados por referencia
    const uniqueMap = new Map();
    toSendArray.forEach((item) => {
      const key = `${item.type}-${item.label}-${item.name}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, item);
      }
    });

    return Array.from(uniqueMap.values());
  };

  const isLastSend = (i, payload) => {
    // Obtener solo los items visibles después del índice actual
    const nextItems = formitems
      .slice(i + 1)
      .filter((item) => item.type !== "freetext" && item.type !== "step" && item.type !== "hidden" && item.type !== "hidden2" && item.filtered !== true && item.emptyOptionalUrlAnswered !== true);

    // Si el campo actual tiene opción de cerrar conversación
    if (formitems[i].type === "select" || formitems[i].type === "selectAndPrice") {
      const option = formitems[i].dataObject?.find((obj) => obj.value === formitems[i].val);
      if (option?.closeConversation) {
        sendMessage = option.closeConversationMessage;
        closeConversationIndex = i + 1;
        isClosedConversationStore.set(true);
        return true;
      }
    }

    // Si no hay más campos visibles, es el último
    return nextItems.length === 0;
  };

  const buildRegExp = (rawPattern) => {
    if (!rawPattern || typeof rawPattern !== "string") return null;
    const match = rawPattern.match(/^\/(.+)\/([gimsuy]*)$/);
    try {
      return match ? new RegExp(match[1], match[2].replace("g", "")) : new RegExp(rawPattern);
    } catch (_) {
      return null;
    }
  };

  const getRegularExpressionValidationText = () => {
    if (data.regularExpressionValidationText) return data.regularExpressionValidationText;
    return translations.regularExpressionValidationText[currentLang] ?? translations.regularExpressionValidationText.en;
  };

  const validate = (type, value, isRequired, validation, subtype) => {
    if (value === "") {
      if (!isRequired) return true;
      err = data.requiredValidationText ? data.requiredValidationText : translations.requiredValidationText[currentLang];
      return false;
    }
    if (type === "checkbox" && isRequired && value === "No") {
      err = data.requiredValidationText ? data.requiredValidationText : translations.requiredValidationText[currentLang];
      return false;
    }
    if (type === "email") {
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        err = data.emailValidationText ? data.emailValidationText : translations.emailValidationText[currentLang];
        return false;
      }
    } else if (type === "tel") {
      if (
        !/^\d{6,15}$/.test(value.num) ||
        (value.code === "34" && !/^[6-8]\d{8}$/.test(value.num) && !/^[9]\d{8,9}$/.test(value.num)) ||
        (value.maxLength && value.num.length !== Number(value.maxLength))
      ) {
        err = data.telValidationText ? data.telValidationText : translations.telValidationText[currentLang];
        return false;
      }
    } else if (type === "number" || type === "price") {
      const numericPattern = type === "price" ? /^\d+(?:[.,]\d+)?$/ : /^\d+$/;
      if (!numericPattern.test(value)) {
        err = data.numberValidationText ? data.numberValidationText : translations.numberValidationText[currentLang];
        return false;
      }
    } else if (type === "url") {
      if (!/(http(s)?:\/\/)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(value)) {
        err = data.urlValidationText ? data.urlValidationText : translations.urlValidationText[currentLang];
        return false;
      }
    } else if (type === "file") {
      if (value.size > 5368709120 || !["pdf", "docx", "xlsx", "jpg", "jpeg", "png", "zip"].includes(value.name.split(".").pop().toLowerCase())) {
        err = data.fileValidationText ? data.fileValidationText : translations.fileValidationText[currentLang];
        return false;
      }
    } else if (type === "text" && subtype === "regularExpression") {
      if (validation) {
        const regExp = buildRegExp(validation);

        if (!regExp || !regExp.test(value)) {
          err = getRegularExpressionValidationText();
          return false;
        }
      }
    } else if (type === "zipcode") {
      if (validation) {
        const regExp = buildRegExp(validation);

        if (!regExp || !regExp.test(value)) {
          err = data.zipcodeValidationText ? data.zipcodeValidationText : translations.zipcodeValidationText[currentLang];
          return false;
        }
      }
    } else if (type === "date" && (subtype === "pickUpDate" || subtype === "dropOffDate")) {
      const today = new Date();
      const selectedDate = new Date(value);
      if (selectedDate < today) {
        err = data.dateBeforeTodayValidationText ? data.dateBeforeTodayValidationText : translations.dateBeforeTodayValidationText[currentLang];
        return false;
      }

      if (subtype === "pickUpDate") {
        const dropOffItem = formitems.find((item) => item.subtype === "dropOffDate");
        if (dropOffItem && dropOffItem.val) {
          const dropOffDate = new Date(dropOffItem.val);
          if (selectedDate < dropOffDate) {
            err = data.dropOffBeforePickUpValidationText
              ? data.dropOffBeforePickUpValidationText
              : translations.dropOffBeforePickUpValidationText[currentLang] ?? "La fecha de recogida debe ser posterior a la de entrega.";
            return false;
          }
        }
      } else if (subtype === "dropOffDate") {
        const pickUpItem = formitems.find((item) => item.subtype === "pickUpDate");
        if (pickUpItem && pickUpItem.val) {
          const pickUpDate = new Date(pickUpItem.val);
          if (selectedDate > pickUpDate) {
            err = data.pickUpBeforeDropOffValidationText
              ? data.pickUpBeforeDropOffValidationText
              : translations.pickUpBeforeDropOffValidationText[currentLang] ?? "La fecha de entrega debe ser anterior a la de recogida.";
            return false;
          }
        }
      }
    }
    err = false;
    return true;
  };

  const sendtocallme = (url = null) => {
    dispatch("callmex", {
      data: formitems.filter((item) => item.type !== "step"),
      url: url,
      notQualified: notQualified,
    });
  };

  const handleParse = (text, i) => {
    const words = text.match("{{([^}]+)}}");
    if (words === null) return text;

    const answerIndex = words[1].includes("answer_") ? parseInt(words[1].split("answer_")[1], 10) : -1;
    let replacement = "";

    if (answerIndex > 0) {
      const sourceItem = formitems[answerIndex - 1];
      const value = sourceItem?.val ?? "";

      if (value && (sourceItem?.type === "select" || sourceItem?.type === "selectAndPrice") && sourceItem?.showWritten) {
        replacement = getWrittenName(value, sourceItem.dataObject);
      } else {
        replacement = value;
      }
    }

    const parsedLabel = text.replace(words[0], replacement);
    formitems[i].label = parsedLabel;
    return parsedLabel;
  };

  /**
   * Updates the width of the progress bar based on the current index.
   * @param {number} index - The current position in the formitems array.
   */
  const updateProgressBar = (index) => {
    const itemsWithoutSteps = formitems.filter((item) => item.type !== "step");
    const answeredCount = formitems.slice(0, index).filter((item) => item.type !== "step").length;
    const progress = itemsWithoutSteps.length ? (answeredCount / itemsWithoutSteps.length) * 100 : 0;
    const progressBar = document.getElementById("chatwith-chatform-progress-bar");
    if (progressBar) {
      progressBar.style.width = progress + "%";
    }
  };

  /**
   * Scrolls to the bottom of the chat box.
   */
  const scrollToBottom = () => {
    tick().then(() => {
      const messageBox = document.getElementsByClassName("chatwith-chat-panel")[0];
      if (messageBox) {
        messageBox.scrollTo({
          top: messageBox.scrollHeight,
          behavior: "smooth",
        });
      }
    });
  };
</script>

<svelte:window bind:innerHeight={screenHeight} />
<div class="chatwith-chat" class:fullScreenMobile class:hasBuyLinks class:notQualified>
  <div class="chatwith-chat-panel" bind:clientHeight={height} style={fullScreenMobileStyle}>
    <div class="chatwith-chat-messages" id="messageBox">
      {#each formitems as bubble, i}
        {#if bubble.type !== "step" && bubble.type !== "hidden" && bubble.type !== "hidden2" && (!bubble.fieldToFilterFrom || bubble.filtered === false)}
          {#if showBot(i, bubble) === true}
            <div class={showDot(i) && "scale-in-left"}>
              <div class="chatwith-chat-msg-header">{activePerson.name}</div>
              {#if bubble.type === "freetext"}
                <ChatBubbleBotFreeText
                  text={interpolatePageVariables(bubble.hval)}
                  showDot={showDot(i)}
                  price={bubble.showPrice && bubble.price && bubble.price > 0 ? bubble.price : null}
                  currency={data.currency}
                  on:message={setVal}
                />
              {:else}
                <ChatBubbleBot text={handleParse(bubble.label, i)} showDot={showDot(i)} />
              {/if}
            </div>

            {#if bubble.legalUrl}
              <div class="checkbox-link scale-in-left">
                {#if isBigperson && bubble.legalCanUseLocalModal && cookieModalExist}
                  {@html `<a target="_blank" onClick="return modalPrivacityTermsCookies('privacityPopup');">${
                    bubble.legalUrlText ?? "Click here to see the Privacy Policy"
                  }</a
                >`}
                {:else}
                  <a target="_blank" href={bubble.legalUrl}>{bubble.legalUrlText ?? "Click here to see the Privacy Policy"}</a>
                {/if}
              </div>
            {/if}
          {/if}
          {#if showUser(i, bubble) === true}
            <div class="scale-in-right">
              <ChatBubbleUser bubbleData={bubble} />
            </div>
          {/if}
        {/if}
      {/each}
    </div>
  </div>
  <div class="chatwith-chat-footer {data.widgetType === 'bigperson' ? '' : 'fixed-bottom'}">
    {#if sent === true || isSent()}
      {#if buyLinks && buyLinks.length > 0}
        {#each buyLinks as item, i}
          <Button
            id={"chatwith-buy-button" + i}
            on:click={() => sendtocallme(item.link)}
            buttonText={item.buttontext}
            showIcon={true}
            iconUrl={data.whatsappIconUrl}
          />
        {/each}
      {:else}
        <div class="chatwith-chat-sent-message">
          {sendMessage}
        </div>
      {/if}
    {:else}
      {#if err}<Typography text={err} error={true} />{/if}

      {#if isLoading}
        <Spinner />
      {:else if type == "checkbox"}
        <ChatCheckBox defaultLanguage={data.defaultLanguage} on:message={setVal} />
      {:else if type === "select" || type === "selectAndPrice"}
        {#if formitems[index].showAsButton || formitems[index].showAsTable}
          <ChatSelectWithButtons
            on:message={setVal}
            options={formitems[index]}
            currency={data?.currency}
            showAsTable={formitems[index].showAsTable}
          />
        {:else if formitems[index].usePredictiveText}
          {#key index}
            <SearchableSelect
              id={`select-${index}`}
              options={toArray(formitems[index].data)}
              placeholder={formitems[index].label}
              showLabel={false}
              label={formitems[index].label}
              required={formitems[index].required}
              item={formitems[index]}
              currency={data?.currency}
              isError={formitems[index].isError}
              isForChat={true}
              on:message={setVal}
            />
          {/key}
        {:else if formitems[index].multiple}
          <MultiSelect
            options={toArray(formitems[index].data)}
            selected={formitems[index].val}
            dataObject={formitems[index].dataObject}
            placeholder={formitems[index].label}
            label={formitems[index].label}
            isError={formitems[index].isError}
            currency={data?.currency}
            isChatForm={true}
            on:change={(e) => {
              formitems[index].val = e.detail;
            }}
            on:message={setVal}
          />
        {:else}
          <ChatSelect on:message={setVal} options={formitems[index]} currency={data?.currency} />
        {/if}
      {:else if type === "tel"}
        <TelField on:submit={setVal} {data} showButton={true} class="chatwith-outer-telfield" />
      {:else if type === "file"}
        <ChatFileUploadBox on:message={setVal} hasBorder={data.widgetType === "bigperson"} fullScreenMobile={data.expandFullScreenMobile} />
      {:else if type === "gender"}
        <ChatGenderSelector
          options={formitems[index].dataObject}
          label={formitems[index].label}
          showWritten={formitems[index].showWritten}
          on:message={setVal}
        />
      {:else if type === "date"}
        <ChatDatePicker placeholder={formitems[index].label} on:message={setVal} />
      {:else if type === "time"}
        <ChatTimePicker placeholder={formitems[index].label} on:message={setVal} />
      {:else}
        <ChatTextBox
          on:message={setVal}
          {type}
          item={formitems[index]}
          currency={data?.currency}
          fullScreenMobile={data.expandFullScreenMobile}
          translateChatAnswer={data.translateChatAnswer}
        />
      {/if}
    {/if}
    {#if data.showBrandInWidget}
      <div class="chatwith-brand" style="font-size: 13px; font-weight:600; margin-top: 10px; color: #666; text-align: center">
        {#if data.brandNameUrl}
          <span><a style="color: blueviolet; font-size: 13px;" target="_blank" href={addHttpsToUrl(data.brandNameUrl)}>{data.brandName}</a></span>
        {:else}
          <span style="font-size: 13px;">{data.brandName}</span>
        {/if}
      </div>
    {/if}
  </div>
</div>
